import React, { useState, useRef, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import swal from "sweetalert";
import { useGetCurrenciesQuery, usePutCurrencyMutation } from "../../../../../features/financialMangement/settings/currency/currencyApiSlice";
import { CSVLink } from "react-csv";
import { notifyError, notifySuccess } from "../../../../../helpers/Notify";

const Currency = () => {
  const [putCurrency, { isLoading, isError, error }] = usePutCurrencyMutation();
  const { data: currencies = [], refetch } = useGetCurrenciesQuery();

  useEffect(() => {
    refetch();
  }, []);

  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const user = localStorage.getItem("user");
  const [search, setSearch] = useState("");
  const recordsPage = 13;
  const lastIndex = currentPage * recordsPage;
  const firstIndex = lastIndex - recordsPage;

  const filterCurrencies = () => {
    if (!search) return currencies?.currencies || [];

    return currencies?.currencies?.filter((currency) => {
      const name = currency?.name?.toString().toLowerCase();
      const symbol = currency?.symbol?.toString().toLowerCase();
      const code = currency?.code?.toString().toLowerCase();

      return (
        name.includes(search.toLowerCase()) ||
        symbol.includes(search.toLowerCase()) ||
        code.includes(search.toLowerCase())
      );
    });
  };

  const filteredCurrencies = filterCurrencies();
  const records = filteredCurrencies?.slice(firstIndex, lastIndex);
  const npage = Math.ceil((filteredCurrencies?.length || 0) / recordsPage);
  const number = [...Array(npage + 1).keys()].slice(1);

  function prePage() {
    if (currentPage !== 1) {
      setCurrentPage(currentPage - 1);
    }
  }
  function changeCPage(id) {
    setCurrentPage(id);
  }
  function nextPage() {
    if (currentPage !== npage) {
      setCurrentPage(currentPage + 1);
    }
  }

  const handleDelete = (currency) => {
    let updatedCurrency = { ...currency };
    updatedCurrency.isDeleted = true;
    updatedCurrency.updatedBy = user?.userId;

    putCurrency({
      id: updatedCurrency?.currencyId,
      updatedCurrency,
    })
      .unwrap()
      .then((response) => {
        notifySuccess("Currency deleted successfully");
        refetch();
        navigate("currencies");
      })
      .catch((error) => {
        console.error("Error updating service", error);
        notifyError(error);
      });
  };

  const handleEdit = (currency) => {
    navigate("currency/edit/" + currency?.currencyId);
  };

  const handleView = (currency) => {
    navigate("currency/view/" + currency?.currencyId);
  };

  const SweetAlert = (currency) =>
    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this data!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        handleDelete(currency);

      } else {
        swal("Your data is safe!");
      }
    });
  const headersTitle = [
    { label: "#", key: "index" },
    { label: "Name", key: "name" },
    { label: "Symbol", key: "symbol" },
    { label: "Code", key: "code" },

  ];
  const csvlink = {
    headers: headersTitle,
    data: filteredCurrencies.map((currency, index) => ({
      index: index + 1,
      name: currency?.name,
      symbol: currency?.symbol,
      code: currency?.code,

    })),
    filename: "Currencies.csv",
  };
  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              <div className="card-body p-0">
                <div className="table-responsive active-projects task-table">
                  <div className="tbl-caption d-flex justify-content-between align-items-center">
                    <h4 className="heading mb-0">Currencies</h4>
                    {filteredCurrencies?.length > 0 && (
                      <CSVLink
                        {...csvlink}
                        className="btn btn-primary light btn-sm me-2 "
                        style={{ marginLeft: '560px', height: "38px", whiteSpace: "nowrap" }}
                      >
                        <i className="fa-solid fa-file-excel"
                          style={{ alignItems: "center", marginTop: "7px", }}
                        /> Export Report
                      </CSVLink>
                    )}
                    <div className="d-flex align-items-center">
                      <input
                        type="text"
                        name="search"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        placeholder="Search"
                        className="form-control me-2"
                      />
                      <Link
                        to={"create-currency"}
                        className="btn btn-primary light btn-sm me-2"
                        style={{ whiteSpace: 'nowrap', padding: '0.775rem 1.75rem' }} // Ensure text doesn't wrap
                      >
                        <i className="fa-solid fa-plus me-2"></i>Add Currency
                      </Link>
                    </div>
                  </div>
                  <div
                    id="task-tbl_wrapper"
                    className="dataTables_wrapper no-footer"
                  >
                    <table
                      id="empoloyeestbl2"
                      className="table ItemsCheckboxSec dataTable no-footer mb-2 mb-sm-0"
                    >
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Name</th>
                          <th>Symbol</th>
                          <th>Code</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {records?.map((currency, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{currency?.name}</td>
                            <td>{currency?.symbol}</td>
                            <td>{currency?.code}</td>
                            <td>
                              <span
                                onClick={() => handleView(currency)}
                                style={{
                                  marginRight: "8px",
                                  color: "blue",
                                  cursor: "pointer",
                                }}
                              >
                                <i className="fas fa-eye" title="View"></i>
                              </span>
                              <span
                                onClick={() => handleEdit(currency)}
                                style={{
                                  marginRight: "8px",
                                  color: "green",
                                  cursor: "pointer",
                                }}
                              >
                                <i className="fas fa-edit" title="Edit"></i>
                              </span>
                              <span
                                onClick={() => SweetAlert(currency)}
                                style={{ color: "red", cursor: "pointer" }}
                              >
                                <i className="fas fa-trash" title="Delete"></i>
                              </span>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    <div className="d-sm-flex text-center justify-content-between align-items-center">
                      <div className="dataTables_info">
                        Showing {lastIndex - recordsPage + 1} to{" "}
                        {filteredCurrencies?.length < lastIndex
                          ? filteredCurrencies?.length
                          : lastIndex}{" "}
                        of {filteredCurrencies?.length} entries
                      </div>
                      <div
                        className="dataTables_paginate paging_simple_numbers justify-content-center"
                        id="example2_paginate"
                      >
                        <Link
                          className="paginate_button previous disabled"
                          to="#"
                          onClick={prePage}
                        >
                          <i className="fa-solid fa-angle-left" />
                        </Link>
                        <span>
                          {number.map((n, i) => (
                            <Link
                              className={`paginate_button ${currentPage === n ? "current" : ""
                                } `}
                              key={i}
                              onClick={() => changeCPage(n)}
                            >
                              {n}
                            </Link>
                          ))}
                        </span>
                        <Link
                          className="paginate_button next"
                          to="#"
                          onClick={nextPage}
                        >
                          <i className="fa-solid fa-angle-right" />
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Currency;